import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {RouterSegments} from 'src/app/models/router-segments';
import {Permission} from '../../models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { translate } from '@jsverse/transloco';
import { PermissionValues } from 'src/app/models/permission-values';
import { PermissionService } from 'src/app/services/api/permission.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  DataZone = DataZone;
  DeployStatus = DeployStatus;
  tenant: string;
  enterpriseClient: boolean;
  deployedStatus: any[] = [];
  RouterSegments = RouterSegments;
  instanceCountdata: any;
  tenantsList: any[] = [];
  selectedTenant: any;
  instanceDetails: any[] = [];
  instanceData: any[] = [];
  instanceByCount: any[] = [];
  instanceList: any[] = [];
  instanceByDatazone: any[] = [];
  instanceByClass: any[] = [];
  instanceByStatus: any[] = [];
  datazoneColumns: string[] = ['name', 'value'];
  instanceBySolutionPiechart: any;
  instanceByMonthChart: any;
  monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  yearDropdown = [];
  selectedYear: string;
  chartData: any;
  overallInstances: number;
  insightTiles = [
    {
      icon: 'account_balance',
      title: 'TENANT_DASHBOARD.OVERALL_TENANTS',
      count: 0,
      link: RouterSegments.TENANT_LIST,
      loading: true
    },
    // Commenting below code as instance card not needed now
    // {
    //   icon: 'language',
    //   title: 'TENANT_DASHBOARD.OVERALL_INSTANCES',
    //   count: 0,
    //   link: RouterSegments.INSTANCE,
    //   loading: true
    // },
    {
      key: 'deployed',
      icon: 'task_alt',
      title: 'TENANT_DASHBOARD.DEPLOYED',
      count: 0,
      loading: true
    },
    {
      key: 'deploying',
      icon: 'sync',
      title: 'TENANT_DASHBOARD.DEPLOYING',
      count: 1,
      loading: true
    }
  ];

  isTenantFailed = false;
  isInstanceFailed = false;

  colorsByStatus = [
    {status: DeployStatus.DEPLOYING, color: '#EF7839'},
    {status: DeployStatus.TERMINATING, color: '#EF7839'},
    {status: DeployStatus.CONFIGURING, color: '#EF7839'},
    {status: DeployStatus.UPDATING, color: '#EF7839'},
    {status: DeployStatus.TESTING, color: '#EF7839'},
    {status: DeployStatus.OPERATION_INPROGRESS, color: '#EF7839'},
    {status: DeployStatus.FAILOVER_APPLYING, color: '#EF7839'},
    {status: DeployStatus.FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.PRE_FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.POST_FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.STARTING_AGENT, color: '#EF7839'},
    {status: DeployStatus.STOPPING_AGENT, color: '#EF7839'},
    {status: DeployStatus.DEPLOYED, color: '#188038'},
    {status: DeployStatus.TERMINATED, color: '#188038'},
    {status: DeployStatus.CONFIGURED, color: '#188038'},
    {status: DeployStatus.UPDATED, color: '#188038'},
    {status: DeployStatus.TESTED, color: '#188038'},
    {status: DeployStatus.FAILED, color: '#B53B20'},
    {status: DeployStatus.TERMINATION_FAILED, color: '#B53B20'},
    {status: DeployStatus.CONFIGURATION_FAILED, color: '#B53B20'},
    {status: DeployStatus.UPDATE_FAILED, color: '#B53B20'},
    {status: DeployStatus.TEST_FAILED, color: '#B53B20'},
    {status: DeployStatus.FAILOVER_FAILED, color: '#B53B20'},
    {status: DeployStatus.FAILBACK_FAILED, color: '#B53B20'},
    {status: DeployStatus.PRE_FAILBACK_FAILED, color: '#B53B20'},
    {status: DeployStatus.POST_FAILBACK_FAILED, color: '#B53B20'}
  ];

  constructor(private authService: AuthService, private tenantService: TenantService, public datepipe: DatePipe,
    private toastrService: CustomToastrService, private router: Router, private instanceService: InstancesService,
    public sidenaveService: SidenavService, private toastrErrorService: ToastrErrorService, private permissionsService: PermissionService) {
    
  }

  ngOnInit(): void {
    // localStorage.setItem('tenantDashboardTenantId', '');
    this.sidenaveService.selectedMenu = '';
    this.tenant = this.authService.principal.provider;
    if (this.authService.scope !== '/global') {
      this.getAssignedPermissions();
    } else {
      this.getTenantsList();
      this.getAllInstanceDetails();
    }
  }

  getAssignedPermissions(): void {
    let scope = '/global';
    this.authService.scope = scope;
    this.permissionsService.getAuthAssignedPermissions(scope)
    .pipe().subscribe(response => {
      this.authService.assignedPermissions = response.permissions;
      this.getTenantsList();
      this.getAllInstanceDetails();
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getAllInstanceDetails(): void {
    this.instanceService.getInstances()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        if (!this.overallInstances) {
          this.overallInstances = data.total;
          const instanceObj = {
            size: this.overallInstances
          };
          this.instanceService.getInstances(instanceObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instances => {
              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYED).count = instances.data
                .filter(instance => instance.status === DeployStatus.DEPLOYED).length;
              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYED).loading = false;
              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYING).count = instances.data
                .filter(instance => instance.status === DeployStatus.DEPLOYING).length;
              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYING).loading = false;
            });
        }
        // Commenting below code as instance card not needed now
        // this.insightTiles.find(item => item.link === 'instance').count = this.overallInstances;
        // this.insightTiles.find(item => item.link === 'instance').loading = false;
        this.getInstanceDetails(this.selectedTenant);
      }
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getTenantsList(): void {
    this.isTenantFailed = false;
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.tenantsList = data;
          this.tenantsList = data.sort((a, b) => (a.tenantId.toLowerCase() < b.tenantId.toLowerCase()) ? -1 : 1);
          this.selectedTenant = this.tenantsList[0];
          this.insightTiles.find(item => item.link === 'tenants').count = this.tenantsList.length;
          this.insightTiles.find(item => item.link === 'tenants').loading = false;
        }
      },
        (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          this.isTenantFailed = true;
        });
  }

  tenantSelectionChanged(event): void {
    this.getInstanceDetails(event);
  }

  getInstanceDetails(selectedTenant): void {
    this.isInstanceFailed = false;
    this.instanceByDatazone = [];
    this.instanceByClass = [];
    this.instanceByStatus = [];
    this.yearDropdown = [];
    this.chartData = [];
    const instanceObj = {
      tenantId: selectedTenant?.tenantId,
      size: this.overallInstances
    };
    this.instanceService.getInstances(instanceObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instanceDetails = data.data;
          this.createInstanceByDatazoneTable();
          this.createInstanceDeploymentClass();
          this.createInstanceDeploymentStatus();
        }
      },
        (error) => {
          this.isInstanceFailed = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }


  createInstanceDeploymentStatus(): void {
    this.deployedStatus = [
      {
        key: 'deployed',
        name: 'Depolyed',
        value: 0
      },
      {
        key: 'deploying',
        name: 'Deploying',
        value: 0
      }
    ];
    this.instanceDetails.forEach(instance => {
      if (instance.status === 'deployed') {
        const obj = this.deployedStatus.find(item => item.key === 'deployed');
        obj.value = obj.value + 1;
      } else if (instance.status === 'deploying') {
        const obj = this.deployedStatus.find(item => item.key === 'deploying');
        obj.value = obj + 1;
      }
    });
  }


  createInstanceDeploymentClass(): void {
    this.instanceByClass = [
      {
        key: 'A',
        name: 'Class A',
        value: 0
      },
      {
        key: 'B',
        name: 'Class B',
        value: 0
      },
      {
        key: 'C',
        name: 'Class C',
        value: 0
      },
      {
        key: 'D',
        name: 'Class D',
        value: 0
      },
    ];

    this.instanceDetails.forEach(instance => {
      if (instance.deploymentClass === 'A') {
        const obj = this.instanceByClass.find(item => item.key === 'A');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'B') {
        const obj = this.instanceByClass.find(item => item.key === 'B');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'C') {
        const obj = this.instanceByClass.find(item => item.key === 'C');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'D') {
        const obj = this.instanceByClass.find(item => item.key === 'D');
        obj.value = obj.value + 1;
      }
    });
  }

  createInstanceByDatazoneTable(): void {
    this.instanceByDatazone = [
      {
        key: 'development',
        name: 'Development',
        value: 0
      },
      {
        key: 'secure',
        name: 'PII',
        value: 0
      },
      {
        key: 'test',
        name: 'TEST',
        value: 0
      },
      {
        key: 'live',
        name: 'Live',
        value: 0
      }
    ];
    this.instanceDetails.forEach(instance => {

      if (instance.dataZone === DataZone.DEVELOPMENT) {
        const obj = this.instanceByDatazone.find(item => item.key === 'development');
        obj.value = obj.value + 1;
      } else if (instance.dataZone === DataZone.SECURE) {
        const obj = this.instanceByDatazone.find(item => item.key === 'secure');
        obj.value = obj.value + 1;
      } else if (instance.dataZone === 'test') {
        const obj = this.instanceByDatazone.find(item => item.key === 'test');
        obj.value = obj.value + 1;
      } else if (instance.dataZone === DataZone.LIVE) {
        const obj = this.instanceByDatazone.find(item => item.key === 'live');
        obj.value = obj.value + 1;
      }

      const statusTypeExist = this.instanceByStatus.find(item => item.name === instance.status);
      if (statusTypeExist) {
        statusTypeExist.value = statusTypeExist.value + 1;
      } else {
        const obj = {
          name: '',
          value: 0,
        };
        obj.name = instance.status;
        obj.value = obj.value + 1;
        this.instanceByStatus = [...this.instanceByStatus, obj];
      }

      const dateCreated = this.datepipe.transform(instance.dateCreated, 'MMM,y')?.split(',');
      if (dateCreated) {
        if (!(this.yearDropdown.find(item => item === dateCreated[1]))) {
          this.yearDropdown = [...this.yearDropdown, dateCreated[1]];
        }
        const dateExist = this.chartData.find(data => data.month === dateCreated[0] && data.year === dateCreated[1]);
        if (dateExist) {
          this.chartData.find(data => data.month === dateCreated[0] && data.year === dateCreated[1]).value = dateExist.value + 1;
        } else {
          const chartDataObj: any = {};
          chartDataObj.month = dateCreated[0];
          chartDataObj.year = dateCreated[1];
          chartDataObj.value = 1;
          if (instance.status === 'deployed') {
            chartDataObj.deployed = 1;
          } else if (instance.status === 'deploying') {
            chartDataObj.deploying = 1;
          }
          else {
            chartDataObj.deploying = 0;
          }
          this.chartData = [...this.chartData, chartDataObj];
        }
      }
    });
    this.selectedYear = this.yearDropdown[0];
    this.createInstanceBySolutionPiechart();
    this.createInstanceByMonthData();
  }

  createInstanceBySolutionPiechart(): void {
    const colorCodes = [];
    this.instanceByStatus.forEach(item => {
      const matchStatus = this.colorsByStatus.find(element=> element.status.toLocaleLowerCase() === item?.name?.toLocaleLowerCase());
      if (matchStatus) {
        colorCodes.push(matchStatus.color);
      }

      item.name = item?.name?.charAt(0).toUpperCase() + item.name.slice(1) + ' (' + item.value + ')';
    });

    this.instanceBySolutionPiechart = {
      title: {
        text: this.instanceDetails?.length,
        subtext: 'No of Environments',
        subtextStyle: {
          color: '#293276',
          fontFamily: 'worksans',
        },
        top: 'center',
        right: 'center',
        textStyle: {
          color: '#293276',
          fontFamily: 'worksans',
          fontSize: 50,
          fontWeight: 600,
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}',
      },
      legend: {
        selectedMode: false,
        show: true,
        top: 'center',
        right: '0%',
        orient: 'vertical',
        type: 'scroll',
        itemGap: 10,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: {
          color: '#293276',
          fontFamily: 'worksans',
          fontSize: 12
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          top: 20,
          bottom: 10,
          label: {
            show: false,
            position: 'bottom',
            formatter: '',
            fontSize: '20'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0
          },
          color: colorCodes,
          data: this.instanceByStatus,
        }
      ]
    };
  }

  yearSelectionChanged(event): void {
    this.selectedYear = event;
    this.createInstanceByMonthData();
  }

  createInstanceByMonthData(): void {
    let seriesData: any = [];
    this.monthArray.forEach(month => {
      if (this.chartData.find(item => item.month === month && item.year === this.selectedYear)) {
        seriesData = [...seriesData, this.chartData.find(item => item.month === month)];
      } else {
        const obj = {
          month,
          value: 0,
        };
        seriesData = [...seriesData, obj];
      }
    });
    const max = Math.max(...(seriesData.map(item => item.value)));
    this.instanceByMonthChart = {
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.monthArray,
        axisLabel: {
          show: true,
          formatter: '{fontStyle|' + `{value}` + '}',
          interval: 0,
          rich: {
            fontStyle: {
              color: '#293276',
              fontFamily: 'WorkSans',
            },
          }
        },
        axisLine: {
          lineStyle: {
            color: '#D1D9E3'
          }
        }
      },
      yAxis: {
        type: 'value',
        min: Math.min(...(seriesData.map(item => item.value))),
        max: max < 5 ? max + 2 : max,
        minInterval: 1,
        axisLabel: {
          show: true,
          formatter: '{fontStyle|' + `{value}` + '}',
          rich: {
            fontStyle: {
              color: '#293276',
              fontFamily: 'WorkSans',
            },
          }
        },
        splitLine: {
          lineStyle: {
            color: '#D1D9E3'
          }
        },
      },
      series: [
        {
          name: 'Total Environments',
          data: seriesData.map(item => item.value),
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#293276'
          },
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#293276',
          },
        },
        {
          name: 'Deployed',
          data: seriesData.map(item => item.deployed),
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#3961A6'
          },
          type: 'bar',
          smooth: true,
          lineStyle: {
            color: '#3961A6',
          },
        },
        {
          name: 'Deploying',
          data: seriesData.map(item => item.deploying),
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: '#F08261'
          },
          type: 'bar',
          smooth: true,
          lineStyle: {
            color: '#F08261',
          },
        },
      ],
    };
  }

  viewDetails(menuItem): void {
    this.router.navigate(['/temenoscom', menuItem]);
  }
}
